module.exports = __webpack_public_path__ + "img/BlinkArt_Sword15_Lava.0de3586a.png";